import { render, staticRenderFns } from "./Logo.vue?vue&type=template&id=dae19c3c&scoped=true&"
import script from "./Logo.vue?vue&type=script&lang=js&"
export * from "./Logo.vue?vue&type=script&lang=js&"
import style0 from "./Logo.vue?vue&type=style&index=0&id=dae19c3c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dae19c3c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LogoPathTitle: require('/Users/romzat/Sites/romza-web-2/components/LogoPathTitle.vue').default,LogoPath: require('/Users/romzat/Sites/romza-web-2/components/LogoPath.vue').default})
